import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MixpanelService } from '../../../common/services/mixpanel.service';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-logout',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: []
})
export class LogoutComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private mixpanel: MixpanelService
  ) {}

  ngOnInit() {
    const { next, error, timeout } = this.route.snapshot.queryParams;

    if (error) {
      this.toastr.error(error);
    }

    if (timeout) {
      this.mixpanel.track('mix_logout_timeout');
    }

    this.authService.logout(true, next);
  }
}
